// @ts-ignore
import bg from './assets/rewarded.webp';
// @ts-ignore
import button from './assets/button.webp';
import {useSequentialModalContext} from '@basicComponents/sequential-modal/context';
import {downloadApk} from '@utils';
import CloseIcon from '@businessComponents/down-app-modal/close';
import React from 'react';

export const DOWNLOAD_REWARDED = 'DOWNLOAD_REWARDED';

// 领取过。但是在h5页面
export default function Rewarded() {
  const {goToNext} = useSequentialModalContext();
  return (
    <div className="flex flex-col items-center">
      <div className="text-[#FE0] text-2xl font-extrabold uppercase ">
        Download the app
      </div>
      <div className="text-white text-xl font-medium text-center w-[17.5625rem] mt-2.5">
        to claim your rewards
      </div>
      <div
        className="h-[13.75rem] w-[16.8125rem] bg-full relative mt-5"
        onClick={() => {
          downloadApk();
          goToNext();
        }}
        style={{
          backgroundImage: `url(${bg})`,
        }}>
        <div
          className="w-[15.3125rem] h-[2.9375rem] bg-full absolute bottom-0 left-1/2 -translate-x-1/2 flex justify-center items-center font-bold text-white text-xl"
          style={{
            backgroundImage: `url(${button})`,
          }}>
          Go to download
        </div>
      </div>
      <div className="flex items-center justify-center mt-6">
        <div className="border border-white rounded-full flex items-center justify-center size-8">
          <CloseIcon onClick={goToNext} class="size-2.5" />
        </div>
      </div>
    </div>
  );
}
